module.exports = "<button type=\"button\" class=\"btn btn-blue\" ng-click=\"$ctrl.review()\">\r\n    Dodaj opinię\r\n</button>"